export default __webpack_public_path__ + "static/media/external-link.724ddaf2.svg";